import React, { useEffect } from 'react'
import Cookies from 'js-cookie'
import { useDispatch, useSelector } from 'react-redux'
import { useClearCache } from 'react-clear-cache'
import * as Sentry from '@sentry/react'
import 'bootstrap/dist/css/bootstrap.css'
import 'antd/dist/antd.css'
import 'Scss/app.scss'
import Router from 'Router/index'
import { removeCookiesHandler } from 'Constants/functions'
import {
  rehydrateToken,
  getCuratorRank,
  getUserInfo,
  logOut,
} from 'Redux/actions/auth'
import {
  getArtistSpotifyConnections,
  getCampaigns,
} from 'Redux/actions/campaignActions'
import { getPlaylists } from 'Redux/actions/playListsActions'
import { getIsAuth, getIsArtist, getUserId } from 'Redux/selectors/auth'
import { getRanks } from 'Redux/actions/rankActions'
import {
  getArtistNotifications,
  getCuratorNotifications,
} from 'Redux/actions/notificationsActions'
import {
  getRejectReasons,
  getWordsBlacklist,
} from 'Redux/actions/reviewsActions'
import { getRecipientBankDetails } from 'Redux/actions/transferwiseActions'

const App = () => {
  const dispatch = useDispatch()
  const isAuth = useSelector(getIsAuth)
  const isArtist = useSelector(getIsArtist)
  const userId = useSelector(getUserId)

  const { isLatestVersion, emptyCacheStorage } = useClearCache()

  useEffect(() => {
    userId && Cookies.set('sondcsrd', userId)
  }, [userId])

  useEffect(() => {
    async function clearCache() {
      if (!isLatestVersion) await emptyCacheStorage()

      let isCleared
      const localStorageIsCleared = localStorage.getItem('isCleared')

      if (localStorageIsCleared) {
        isCleared = JSON.parse(localStorageIsCleared)
      }

      if (!isCleared) {
        localStorage.clear()
        localStorage.setItem('isCleared', JSON.stringify(true))
      }
    }

    clearCache()
  }, [isLatestVersion, emptyCacheStorage])

  useEffect(() => {
    if (isAuth) {
      if (isArtist) {
        dispatch(getCampaigns())
        dispatch(getArtistNotifications())
        dispatch(getArtistSpotifyConnections())
      } else {
        dispatch(getRanks())
        dispatch(getPlaylists())
        dispatch(getRejectReasons())
        dispatch(getCuratorNotifications())
        dispatch(getWordsBlacklist())
        dispatch(getCuratorRank())
        dispatch(getRecipientBankDetails())
      }
      dispatch(
        getUserInfo((error: string) => {
          if (error) {
            dispatch(logOut())
            removeCookiesHandler()
          }
        })
      )
    }

    dispatch(rehydrateToken())
  }, [isAuth, isArtist])

  return (
    <div>
      <Router />
    </div>
  )
}

export default Sentry.withProfiler(App)
